export const Constant = {
  DEFAULT_DURATION_IN_MS: 500,
  DEFAULT_DELAY_IN_MS: 0,

  MIN_SCALE_X: 1,
  MAX_SCALE_X: 1.2,

  INITIAL_VELOCITY: 10,

  REST_SPEED_THRESHOLD: 0.01,
  DAMPING: 3,
};
